import { ActionsUnion } from 'utils'
import { clientActionLogin } from './ClientAction'

export const AuthActions = {
  login: clientActionLogin
}

export type AuthActions = ActionsUnion<typeof AuthActions>
